package components

import common.ECssClasses
import components.items.BackButtonIcon
import core.extensions.toClassName
import core.ionic.IonButtons
import core.ionic.IonMenuButton
import core.ionic.IonToolbar
import csstype.NamedColor
import csstype.px
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.div

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 18.10.22
 * Author : marcusspors
 */

external interface ToolbarProps : Props {
    var mEndViews: List<FC<*>>?
    var mIsBackNavigation: Boolean
}

val Toolbar = FC<ToolbarProps> { props ->

    val mIsBackNavigation = props.mIsBackNavigation
    val mEndViews = props.mEndViews

    IonToolbar {
        css(ECssClasses.TOOLBAR_BACKGROUND.toClassName()) {
            padding = 5.px
        }
        mEndViews?.forEach {
            div {
                slot = "end"
                it.invoke()
            }
        }

        IonButtons {
            slot = "start"
            if(mIsBackNavigation) {
                BackButtonIcon()
            }else {
                IonMenuButton {
                    css {
                        color = NamedColor.black
                    }
                }
            }
        }
    }
}